import React from 'react';
import { X } from 'lucide-react';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    showDefaultButton?: boolean; // Nueva prop para controlar el botón por defecto
    buttonText?: string; // Texto opcional para el botón
}

const Modal: React.FC<ModalProps> = ({ 
    isOpen, 
    onClose, 
    children, 
    size = 'md',
    showDefaultButton = false, // Por defecto no mostrar botón
    buttonText = 'Aceptar' 
}) => {
    if (!isOpen) return null;

    const sizeClasses = {
        sm: 'max-w-md',
        md: 'max-w-lg',
        lg: 'max-w-2xl',
        xl: 'max-w-4xl'
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className={`bg-white rounded-xl p-6 w-full ${sizeClasses[size]} shadow-2xl relative`}>
                
                {/* Botón de cerrar superior derecho */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <X size={20} />
                </button>

                {/* Contenido dinámico */}
                <div className="text-center">
                    {children}
                </div>

                {/* Footer del Modal con el botón opcional */}
                {showDefaultButton && (
                    <div className="mt-6 flex justify-center">
                        <button
                            onClick={onClose}
                            className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all shadow-md"
                        >
                            {buttonText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;